import { render, staticRenderFns } from "./AdminEditMailTextFormCard.vue?vue&type=template&id=5f0b6f72&scoped=true&"
import script from "./AdminEditMailTextFormCard.vue?vue&type=script&lang=js&"
export * from "./AdminEditMailTextFormCard.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditMailTextFormCard.vue?vue&type=style&index=0&id=5f0b6f72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b6f72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VCol,VRow,VTextField,VTextarea})
